import React, { useEffect } from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useDrawer } from "@/utils/DrawerProvider";
import { FaArrowLeft } from "react-icons/fa";
import { IconButton, SwipeableDrawer } from "@mui/material";
import { styled } from "@mui/system";
import { useTranslation } from "react-i18next";

export interface DrawerOption {
  open: boolean;
  content: React.ReactNode;
  title: string | JSX.Element;
  onClose?: Function;
  size?: "md" | "lg" | "sm";
  id: string;
  anchor?: "top" | "left" | "bottom" | "right"
}
type Anchor = "top" | "left" | "bottom" | "right";
const DrawerContainer: React.FC<DrawerOption> = ({
  open,
  content,
  title,
  size,
  onClose,
  anchor,
  id,
}) => {
  const { t, i18n } = useTranslation();
  const currentLocale = i18n.language;
  const { closeDrawer } = useDrawer();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });
    };
    useEffect(() => {
      //@ts-ignore
      window.back = function () {
        console.log(open)
      if(open==true)
       closeDrawer(id?? "")
        return
      };
    }, [open]); 
  
  return (
    <SwipeableDrawerStyled
      id={id}
      onOpen={toggleDrawer(currentLocale == "ar" ? "left":"right", true)}
      anchor={anchor ? anchor : currentLocale == "ar" ? "left":"right"}
      swipeAreaWidth={0}
      open={open}
      onClose={() => onClose?.() ?? closeDrawer(id)}
      className={currentLocale == "ar" ? "rtl" : ""}
    >
      {/* <ModalClose /> */}
      <div className="auto-c1 vcenter">
        <IconButton size="medium" onClick={() => onClose?.() ?? closeDrawer(id)}>
          {" "}
          <FaArrowLeft className="blue p5" />
        </IconButton>
        {typeof title == "string" && (
          <DialogTitle
            style={{
              fontFamily: "Plus Jakarta Sans",
              color: "#16489f",
              fontWeight: "500",
            }}
          >
            {title}
          </DialogTitle>
        )}
        {typeof title != "string" && (
          <div style={{ color: "#16489f" }}>{title}</div>
        )}
      </div>

      <DialogContentStyled >
      {React.cloneElement(content as React.ReactElement<any>, {drawerid: id })}
      </DialogContentStyled>
      <br />
    </SwipeableDrawerStyled>
  );
};
export default DrawerContainer;








const DialogContentStyled = styled(DialogContent)`
  ::-webkit-scrollbar {
    display: none;
  }
  font-size: 15px;
  color: #16489f;
  padding-bottom: 50px; 
`;
const SwipeableDrawerStyled = styled(SwipeableDrawer)`
    width: 60vw !important;
    transition: 10s;
  .css-1160xiw-MuiPaper-root-MuiDrawer-paper , .css-4t3x6l-MuiPaper-root-MuiDrawer-paper, .css-1hmkbl3-MuiDialogContent-root, .css-1ab2xsx, .css-wf16b5 {
    width: 60vw !important;
  } 

  @media screen and (max-width: 1200px) {
    width: 70vw !important;
    .css-1160xiw-MuiPaper-root-MuiDrawer-paper,.css-4t3x6l-MuiPaper-root-MuiDrawer-paper ,.css-1hmkbl3-MuiDialogContent-root , .css-1ab2xsx , .css-wf16b5{
      width: 70vw !important;
    }
  }
  @media screen and (max-width: 800px) {
    width: 100vw !important;
    .css-1160xiw-MuiPaper-root-MuiDrawer-paper , .css-4t3x6l-MuiPaper-root-MuiDrawer-paper, .css-1hmkbl3-MuiDialogContent-root, .css-1ab2xsx , .css-wf16b5{
      width: 100vw !important;
    }
  }
`;
